import { useCallback } from "react";
import {
  useCreateFencyFileDownloadSessionMutation,
  useCreateContractSearchSessionMutation,
  useCreateExploreMemoriesSessionMutation,
  useCreateFencyStreamSessionMutation,
  useCreateMemoryChatSessionMutation,
} from "../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../auth/useLoggedInWithOrgContextState";

export const useFency = () => {
  const [createSession] = useCreateFencyStreamSessionMutation();
  const [createContractSearchSession] = useCreateContractSearchSessionMutation();
  const [createMemoryChatSession] = useCreateMemoryChatSessionMutation();
  const [createExploreMemoriesSession] = useCreateExploreMemoriesSessionMutation();
  const [createFencyFileDownloadSession] = useCreateFencyFileDownloadSessionMutation();
  const authState = useLoggedInWithOrgContextState();

  const fetchCreateStreamClientToken = useCallback(async () => {
    const result = await createSession({
      organizationId: authState.selectedOrg.id,
      personId: authState.me.id,
    }).unwrap();
    return { clientToken: result.clientToken };
  }, [createSession, authState.selectedOrg.id, authState.me.id]);

  const fetchCreateContractSearchClientToken = useCallback(async () => {
    const result = await createContractSearchSession({
      organizationId: authState.selectedOrg.id,
      personId: authState.me.id,
    }).unwrap();
    return { clientToken: result.clientToken };
  }, [createContractSearchSession, authState.selectedOrg.id, authState.me.id]);

  const fetchCreateMemoryChatByMemoryIdClientToken = useCallback(
    async (memoryId: string) => {
      const result = await createMemoryChatSession({
        createMemoryChatSessionRequest: { memoryId },
        organizationId: authState.selectedOrg.id,
        personId: authState.me.id,
      }).unwrap();
      return { clientToken: result.clientToken };
    },
    [createMemoryChatSession, authState.selectedOrg.id, authState.me.id]
  );

  const fetchCreateExploreMemoriesClientToken = useCallback(
    async (conversationId: string) => {
      const result = await createExploreMemoriesSession({
        createExploreMemoriesSessionRequest: { conversationId },
        organizationId: authState.selectedOrg.id,
        personId: authState.me.id,
      }).unwrap();
      return { clientToken: result.clientToken };
    },
    [createExploreMemoriesSession, authState.selectedOrg.id, authState.me.id]
  );

  const fetchFencyFileDownloadClientToken = useCallback(
    async (agentTaskFileId: string) => {
      const result = await createFencyFileDownloadSession({
        createFencyFileDownloadSessionRequest: { agentTaskFileId },
        organizationId: authState.selectedOrg.id,
        personId: authState.me.id,
      }).unwrap();
      return { clientToken: result.clientToken };
    },
    [createFencyFileDownloadSession, authState.selectedOrg.id, authState.me.id]
  );

  return {
    fetchCreateStreamClientToken,
    fetchCreateContractSearchClientToken,
    fetchCreateMemoryChatByMemoryIdClientToken,
    fetchCreateExploreMemoriesClientToken,
    fetchFencyFileDownloadClientToken,
  };
};
